//  PROD CODE PAN + MOBILE NUIMBER No captcha for OVD

import { React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CommonButton from "../../../Components/global-components/CommonButton/CommonButton";
import ToggleButton from "../../../Components/kyc-components/ToggleButton";
import { useDispatch, useSelector } from "react-redux";
import { panUserdata, userPanNumber , userTempPanNumber } from "../../Redux/panCardSlice";
import Loadingoverlay from "../../../Components/global-components/LoadingOverlay/Loadingoverlay";
import TextInput from "../../../Components/global-components/CommonTextInput/TextInput";
import { toggleButton } from "../../Redux/switchToggleSlice";
import { toggleTabs, disableTab } from "../../Redux/slice";
import OtherDocsFrame from "./OtherDocsFrame";
import {
  getPanCardDetails,
  getPanCardDetailsV2,
  getPanCardDetailsV3, // CERSAI API CALL 
} from "../../../services/panCard-service";
import { activeStepper } from "../../Redux/stepperSlice";
import BottomCard from "../../../Components/login-components/bottom-card/BottomCard";
import CommonDropDown from "../../../Components/global-components/CommonDropDown/CommonDropDown";
import AadhaarCardFrame from "./AadhaarCardFrame/AadhaarCardFrame";
import {
  gaFunction,
  MAX_ATTEMPT_TIME_LIMIT,
  scrollIntoViewFunc,
} from "../../../Router";
import { kycName, kycRefId, kycRefIdAddNewKyc,updateIsRecordExist } from "../../Redux/kycDetailsSlice";
import { showGlobalError } from "../../Redux/globalErrorSlice";
import Cookies from "universal-cookie";
// import { decrypt } from "../../../utils/encryption";
import { customerData, updateUserData } from "../../Redux/userData";
import { encrypt, decrypt } from "../../../utils/encryptionV2";
import ErrorBottomDrawer from "../../../Components/global-components/ErrorBottomDrawer/ErrorBottomDrawer";

// CAPTCHA SERVICE
import { getCaptcha, postCaptcha } from "../../../services/captcha-service";
import SyncOutlinedIcon from "@mui/icons-material/SyncOutlined";
import { Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import {CommonTemplate4 ,CommonTemplate2 , CommonTemplate3} from "../../../Components/global-components/CommonModal";
import OtpInput from "react-otp-input";
import styles from "../../OtpScreen/OtpScreen.module.css";
import { sendCkycOtp } from "../../../services/ckyc-otp-service.js";
import CommonRadioButton from "../../../Components/global-components/CommonRadioButton/CommonRadioButton";

const PanCardFrame = ({
  setCersaiLoader,
  setControllerState,
  controller,
  signal,
}) => {
  const navigate = useNavigate();
  const cookies = new Cookies();
  const userDetails = useSelector((state) => state.userDetails.userData);
  const TempPanValue = useSelector((state) => state.panDetails.userTempPanNumber);
  const { panNumber: reduxPanNumber, dob: reduxDob } = userDetails;
  const [panValidationError, setpanValidationError] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [showOtherDocs, setShowOtherDocs] = useState(false);
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [panNumber, setPanNumber] = useState(reduxPanNumber);
  const [dob, setDob] = useState(reduxDob);
  const [switchTab, setSwitchTab] = useState(false);
  const [isDeclarationChecked, setIsDeclarationChecked] = useState(true);
  const [errDrawer, setErrDrawer] = useState(false);

  // const userlocation = useSelector((state) => state.userDetails.geolocation);
  const istoggle = useSelector((state) => state.switchButton.activeSwitch);
  const activeTabs = useSelector((state) => state.Tabs.activeTab);
  const { channelUrl, mi_u, subChannel } = useSelector(
    (state) => state.partnerChannelNameSlice.marutiUserDetails
  );
  const kyc_id = useSelector((state) => state.kycDetails.kycRefId);
  const name = useSelector((state) => state.kycDetails.kycName);
  const Is_IDV3 = useSelector((state) => state.kycDetails.Is_IDV3);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [idvModal,setIDVModal]=useState(false)
   const [isEddFlag, setIsEddFlag] = useState(false);
   const [newKycId, setNewKycId] = useState("");
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
     if(Is_IDV3){
      setIDVModal(false)
    }
    setOpen(false);
  };

  // const [userPanData, setUserPanData] = useState("");
  const [isLoading, setIsloading] = useState(false);
  const [isCersaiLoading, setIsCersailoading] = useState(false);
  function changedateformat(val) {
    const myArray = val.split("-");
    let year = myArray[0];
    let month = myArray[1];
    let day = myArray[2];
    let formatteddate = day + "-" + month + "-" + year;
    return formatteddate;
  }

  const [capthaValidationErr, setCapthaValidationErr] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [imgUrl, setImgUrl] = useState(null);
  const [captchaVal, setCaptchaVal] = useState(null);
  const [sessionID, setSessionID] = useState(null);
  const [captchaErrDrawer, setCaptchaErrDrawer] = useState(false);
  const [openCersaiOtp, setOpenCersaiOtp] = useState(false);
  const [userNumber, setUserNumber] = useState("");
  const [otpValue, setOtpValue] = useState("");
  const [ckycOtpRes, setCkycOtpRes] = useState(null);
  const [isRotating, setIsRotating] = useState(false);
  const [kycName,setKycName]=useState(name || "")

  const panChangeHandler = (value) => {
    let regexPan = /[A-Z]{5}\d{4}[A-Z]{1}/i;
    value = value?.replace(/\s/g, "");
    if (value.length <= 10) {
      setPanNumber(value);
      dispatch(userTempPanNumber(value))
    }
    setpanValidationError(null);
    if (!regexPan.test(value)) {
      setpanValidationError("Enter valid PAN Number.");
    }
  };

  const cersai_error = localStorage.getItem("Cersai_error") || null;
  const cersai_requestID = localStorage.getItem("cersai_requestID") || null;
  
  useEffect(()=>{
     if(cersai_error){
      setOpenCersaiOtp(true);
    }
  },[])

  // panHandler2 function is used for  | -- CERSAI OTP FLOW
  const panHandler2 = () => {
    if(!panValidationError && isDeclarationChecked && panNumber && userNumber?.length == 10) {
      if (panNumber && !["P"].includes(panNumber[3])) {
        setIsloading(false);
        setIsButtonLoading((pre) => !pre);
        handleOpen();
      } else {
        setOtpValue("");
        setIsCersailoading(true);
        sendCersaiOtp();
      }
    } else {
      if(!panNumber && !userNumber) setErrorMessage("Fill in all required details.");
      if(!panNumber) setpanValidationError("Enter valid PAN Number.");
      if(!userNumber) setErrorMessage("Please enter valid mobile no.");
      setIsloading(false);
    }
  };

  const panHandler = () => {
    gaFunction("PAN (CkYC)", "PAN (CKYC) Proceed clicked");

    if(!cersai_requestID) {
    localStorage.setItem('cersai_requestID' , ckycOtpRes?.requestId)
   }

    if (panNumber && !["P"].includes(panNumber[3])) {
      setIsloading(false);
      setIsButtonLoading((pre) => !pre);
      handleOpen();
    } else {
      setCersaiLoader(true); // NEW LOADER
    }
    if ((!panValidationError && isDeclarationChecked && panNumber) || otpValue.length === 6 ) {

      let data = JSON.stringify({
        panNo: panNumber || TempPanValue,
        dob: changedateformat(dob),
        name: userDetails.name,
        mobile: userDetails.phoneNumber || "",
        mobileRedirect: userDetails?.mobileNumber || "",
        channel: channelUrl,
        txnId: mi_u || localStorage.getItem("txnId"),
        kyc_id,
        customerType: "I",
        requestId: ckycOtpRes?.requestId || cersai_requestID,
        otp: otpValue,
      });
      
      if (panNumber && !["P"].includes(panNumber[3])) {
        setIsloading(false);
        setIsButtonLoading((pre) => !pre);
        handleOpen();
      } else {
        setIsloading(true);
        setIsButtonLoading((pre) => !pre);
        if (true) {
          setControllerState(controller); // SET CONTROLLEER HERE
          getPanCardDetailsV3(
            { enc_request: encrypt(data) },
            encodeURIComponent(encrypt(`txnid=${mi_u}`)),
            signal
          )
            .then(function (response) {
              // dispatch(disableTab(true));
              let decData = decrypt(response.enc_response);
              let extractedData = decData.data;
              console.log("EXTRACTED DATA", extractedData);
              dispatch(userTempPanNumber(''))
              // DEDUPESD CONCEPT ADDED IF PAN ALREDY EXIST THEN GO OT SUCCESS PAGE
              if (extractedData?.exists) {
                setCersaiLoader(false); // CLOSE LOADER HERE
                console.log("---DEDUPED ON PAN---");
                setIsloading(false);
                dispatch(activeStepper(3));
                navigate("/Success", {
                  state: {
                    kyc_ref_id: extractedData?.kyc_id,
                    typeOfKyc: extractedData?.status,
                  },
                });
              } else {
                setCersaiLoader(false); // CLOSE LOADER HERE
                console.log("ELSE PAN create new one");
                navigate("/panDetails", {
                  state: {
                    isRouteAllowed: true,
                  },
                });
                // let decData= decrypt(response.enc_response)
                // let extractedData = decData.data;
                //old
                //   dispatch(panUserdata(extractedData));
                //   dispatch(updateUserData({ name: extractedData.fullName }));
                //new
                dispatch(
                  panUserdata({ ...extractedData, dob: changedateformat(dob) })
                );
                dispatch(updateUserData({ name: extractedData?.fullName }));
                dispatch(kycRefIdAddNewKyc(extractedData?.kyc_id || ""));
                dispatch(userPanNumber(panNumber));
                dispatch(activeStepper(1));
                setIsloading(false);
                setIsButtonLoading((prev) => !prev);
              }
            })
            .catch(function (error) {
              setCersaiLoader(false); // CLOSE LOADER HERE
              // dispatch(disableTab(true));
              console.log("---CATCH ERROR---", error);
              if (
                error?.response?.data?.message ===
                "No CKYC number found for the given pan number, click ok to proceed with Other Documents"
              ) {
                setTimeout(() => {
                  setSwitchTab(true);
                  // dispatch(toggleTabs("otherDocs"));
                  dispatch(toggleTabs("aadhaar"));
                }, 1000);
              }
              // handle error
              else {

                if (error.response.data.message.includes('Invalid OTP')) {
                  localStorage.setItem("Cersai_error", error.response.data.message);
                } else {
                  console.log("------handle cersai error on catch------");
                  setIsloading(false);
                  setErrDrawer(true);
                  setSwitchTab(true);
                  //   dispatch(toggleTabs("otherDocs"));
                  dispatch(toggleTabs("aadhaar"));
                  // OTP | after 3 wrong OTP attempt both local items set as null
                  console.log("-------------CLEAR HERE CERSAI OTP && EROR---------------");
                  localStorage.removeItem("Cersai_error", null);
                  localStorage.removeItem('cersai_requestID' , null)
                }
              }
              setIsloading(false);
              setIsButtonLoading((prev) => !prev);
            });
        } else {
          // setIsloading(false);
          // setIsButtonLoading((prev) => !prev);
          // dispatch(
          //   showGlobalError(
          //     "Please try again after 15 Minutes. Maximum attempt exceeded for PAN."
          //   )
          // );
          // cookies.set("pan_attempts", +cookies.get("pan_attempts"), {
          //   expires: new Date(Date.now() + MAX_ATTEMPT_TIME_LIMIT * 1000),
          // });
          // return;
        }
      }
    } else {
      setCersaiLoader(false); // CLOSE LOADER HERE
      setErrorMessage("Fill in all required details.");
      setIsloading(false);
      if (!panNumber || panValidationError) {
        scrollIntoViewFunc("pan_number");
      } else if (!dob) {
        scrollIntoViewFunc("dob");
      } else if (!isDeclarationChecked) {
        scrollIntoViewFunc("pan_dec_checkbox");
      }
    }
  };

  const toggleButtonChangeHandler = (e) => {
    dispatch(toggleButton(e.target.checked));
    // if (!e.target.checked) dispatch(toggleTabs("otherDocs"));
    if (!e.target.checked)
      navigate("/digitalFormNinetySeven", { state: { methodOfKyc: "pan" } });
  };

  const clickHandler = () => {
    if (panNumber && !["P"].includes(panNumber[3])) {
      setIsloading(false);
      setIsButtonLoading((pre) => !pre);
      handleOpen();
      return;
    }
    gaFunction("OVD", "OVD Clicked");
    setShowOtherDocs(true);
    navigate("/kyc");
    dispatch(toggleTabs("otherDocs"));
    // dispatch(toggleButton(false));
  };

  useEffect(() => {
    dispatch(activeStepper(0));
  }, []);

  useEffect(() => {
    let reduxPanValue = reduxPanNumber;
    reduxPanValue = reduxPanValue?.replace(/\s/g, "");
    if (reduxPanValue?.length == 10) {
      setPanNumber(reduxPanValue);
    } else {
      setPanNumber("");
    }
    setDob(reduxDob);
  }, [reduxDob, reduxPanNumber]);

  // CAPTCHA CODE ---STRART---

  useEffect(() => {
    generateCaptcha();
  }, []);

  function generateCaptcha() {
    getCaptcha().then((data) => {
      let decResponse = decrypt(data.enc_response);
      setSessionID(decResponse?.capthchaSessionID);
      sessionStorage.setItem("sessionID", decResponse?.capthchaSessionID);
      let svgString = decResponse?.captchaSvg?.replace(/\\/g, "");
      const svgDataUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
        svgString
      )}`;
      setImgUrl(svgDataUrl);
    });
  }

  function captchaChangeHandler(value) {
    value = value?.replace(/\s/g, "");
    if (value.length <= 6) {
      setCaptchaVal(value);
      setCapthaValidationErr("");
    }
  }

  function regeneratCaptcha(e) {
    e.preventDefault();
    setIsRotating(true);
    setTimeout(()=>setIsRotating(false),1500);
    generateCaptcha();
    setCaptchaVal("");
    setCapthaValidationErr("");
  }

  const captchaHandler = (btnType) => {
    if (captchaVal?.length === 6) {
      console.log(captchaVal);
      const storedValue = sessionStorage.getItem("sessionID");
      if (captchaVal === storedValue) {
         panHandler2() 
        // LATEST flow with | Replace DOB with mobilNumber fro cersai OTP
        // btnType === "panHandler" ? panHandler2() : clickHandler();
        // OLD flow with | DOB
        // btnType === 'panHandler' ? panHandler() : clickHandler()
        sessionStorage.removeItem("sessionID");
        setCaptchaVal("");
        generateCaptcha();
      } else {
        setCaptchaErrDrawer(true);
        generateCaptcha();
        setCaptchaVal("");
      }
    } else {
      // let errmsg = btnType === "panHandler" ? "Proceed" : "OVD";
      let errmsg = "Proceed"
      setCaptchaError(true);
      scrollIntoViewFunc("captcha_number");
      setCapthaValidationErr(`Please enter valid captcha to ${errmsg}.`);
      setIsButtonLoading((prev) => !prev);
    }
  };

  const validateAndSetUserNumber = (value) => {
    let mobileNumberRegex = /^\d{10}$/
    value = value?.replace(/[^0-9]/g, '')
    console.log(mobileNumberRegex.test(value))
    if (value.length <= 10  ) {
      setUserNumber(value);
    }
    // eslint-disable-next-line no-invalid-regexp
    setErrorMessage(null);
    // if (!mobileNumberRegex.test(value)) { // OLD
    if (value?.length !== 10 && value?.length < 10 ) { // NEW
      setErrorMessage("Please enter valid mobile no.");
    }
  };

  const sendCersaiOtp = () => {

    let data = JSON.stringify({
      panNo: panNumber,
      mobileNumber: userNumber, // --- for CERSAI OTP use this key
      mobile: userDetails.phoneNumber,
      name: userDetails.name,
      mobileRedirect: userDetails?.mobileNumber || "",
      channel: channelUrl,
      txnId: mi_u || localStorage.getItem("txnId"),
      kyc_id,
      customerType: "I",
      requestId: ckycOtpRes?.requestId || cersai_requestID,
      otp: otpValue,
    });

    sendCkycOtp({ enc_request: encrypt(data) })
      .then(function (response) {
        console.log("sendCkycOtp res", response);
        let decData = decrypt(response.enc_response);
        let extractedData = decData.data;
        // DEDUPESD CONCEPT ADDED IF PAN ALREDY EXIST THEN GO OT SUCCESS PAGE
        if (extractedData?.exists) {
          setIsloading(false);
          setIsCersailoading(false);
          if(Is_IDV3){
            dispatch(activeStepper(3));
            setIDVModal(true)
            setKycName(extractedData?.name)
            setIsEddFlag(extractedData?.isEdd)
            setNewKycId(extractedData?.kyc_id)
            dispatch(kycRefId(extractedData?.kyc_id))
            dispatch(updateIsRecordExist(extractedData?.exists))
            dispatch(customerData({
              occupation: extractedData?.occupation,
              organization: extractedData?.organizationType}))
          }else{
            dispatch(activeStepper(3));
            navigate("/Success", {
              state: {
                kyc_ref_id: extractedData?.kyc_id,
                typeOfKyc: extractedData?.status,
              },
            });
          }
        } else {
          setCkycOtpRes(decData.data);
          setIsCersailoading(false);
          setOpenCersaiOtp(true);
        }
      })
      .catch(function (err) {
        setIsCersailoading(false);
        setOpenCersaiOtp(false);
      });
  };

  // Redirect or cancel journy of OTP using this function
  const closeOtpTemplate = () => {
    localStorage.removeItem("Cersai_error", null);
    localStorage.removeItem('cersai_requestID' , null)
    setSwitchTab(true);
    dispatch(toggleTabs("aadhaar"));
    setOpenCersaiOtp(false)
  }

  const eddHandler = () => {
    setIDVModal(false)
    if (isEddFlag) {
      navigate("/Success", {
        state: {
          kyc_ref_id: newKycId,
        },
      });
    } else {
      navigate("/eddDetails")
    }
  }

  return (
    <>
      {isLoading ? (
        <Loadingoverlay />
      ) : (
        <>
          {showOtherDocs || istoggle === false ? (
            // <OtherDocsFrame />
            navigate("/digitalFormNinetySeven", { state: { methodOfKyc: "pan" } })
          ) : (
            <>
              {!showOtherDocs && (
                <>
                  <div className="mt-[16px]"></div>

                  <div className="  md:overflow-scroll md:p-0 ">
                    {!(subChannel === "web" && mi_u.slice(0, 3) === "KY3") && (
                      <div className="flex   gap-[10px]  items-center max-w-[100%]">
                        <p>Do you have a valid PAN Number?</p>
                        <ToggleButton
                          onChange={(e) => toggleButtonChangeHandler(e)}
                          checked={istoggle}
                        />
                      </div>
                    )}
                    <div className="mt-5">
                      <label
                        htmlFor="first_name"
                        className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-700"
                      >
                        PAN No.
                      </label>
                      <TextInput
                        placeholder={"PAN Number"}
                        width="md:w-[300px]"
                        value={panNumber}
                        onChange={(e) =>
                          panChangeHandler(e.target.value.toUpperCase())
                        }
                        success={
                          panValidationError || panNumber?.length <= 0
                            ? false
                            : true
                        }
                        id="pan_number"
                        required
                      />
                      {panValidationError && (
                        <p className="text-red-500 text-sm">
                          {panValidationError}
                        </p>
                      )}
                    </div>
                    <div className="mt-5">
                    </div>
                    <TextInput
                      id={"loginNumberField"}
                      value={userNumber}
                      width="md:w-[300px]"
                      type="tel"
                      label={"Mobile number"}
                      placeholder={"Eg.99999 00000"}
                      onChange={(e) => validateAndSetUserNumber(e.target.value)}
                    />
                    {errorMessage && (
                      <p className="text-red-500 mt-2">{errorMessage}</p>
                    )}
                    <div className="flex mt-2">
                      <input
                        id="pan_dec_checkbox"
                        type="checkbox"
                        value={isDeclarationChecked}
                        checked={isDeclarationChecked}
                        className="w-5 h-5  rounded border-gray-300 text-primaryH ring-0 focus:ring-0"
                        onChange={(e) =>
                          setIsDeclarationChecked(e.target.checked)
                        }
                      />
                      <label
                        htmlFor="link-checkbox"
                        className="ml-2 text-sm font-medium text-black "
                        style={{fontSize:"12px"}}
                      >
                        I hereby provide my consent to HDFC ERGO General
                        Insurance Company Limited to retrieve/ verify my KYC
                        documents like Address /ID proof and photograph, from
                        the CERSAI portal against my PAN No. I understand that
                        the said KYC documents shall be relied upon by the
                        Company for processing my policy/refunds/ Claims.
                      </label>
                    </div>
                    <div
                      className="captcha-div"
                      style={{ display: "flex", marginTop: "15px" }}
                    >
                      <img
                        src={imgUrl}
                        style={{
                          border: "1px solid #d1d5db",
                          padding: "5px",
                          borderRadius: "10px",
                          marginRight: "12px",
                        }}
                        alt="Captcha Img"
                      />
                      <Tooltip
                        style={{ margin: "20px 15px 0px 0px" }}
                        id="button-report1"
                        title={"Captcha is mandate from Infosec point of view"}
                      >
                        <InfoIcon sx={{ color: "black", fontSize: "17px" }} />
                      </Tooltip>
                      <SyncOutlinedIcon
                        sx={{
                          color: "black",
                          fontSize: "25px",
                          marginTop: "15px",
                          marginRight: "10px",
                          cursor: "pointer",
                          animation: isRotating ?"rotate360 1.5s ease-in-out":"none"
                        }}
                        onClick={(e) => regeneratCaptcha(e)}
                      />
                      <TextInput
                        placeholder={"Enter Captcha"}
                        // width="md:w-[300px]"
                        value={captchaVal}
                        onChange={(e) => captchaChangeHandler(e.target.value)}
                        success={captchaVal <= 0 ? false : true}
                        //  id="captcha_number"
                        required
                      />
                    </div>
                    {captchaError && (
                      <p
                        className="text-red-500 text-sm"
                        style={{ marginTop: "5px" }}
                      >
                        {capthaValidationErr}
                      </p>
                    )}

                    <div id="captcha_number" style={{ margin: "20px" }}></div>
                  </div>
                  <div className="w-full mt-5 md:mt-0 md:w-[300px] flex md:pb-1">
                    <CommonButton
                      label="Proceed"
                      filled
                      arrow
                      // loading={isButtonLoading}
                      id={"toCompletePanKyc"}
                      onClickHandler={() => {
                        //  setIsloading(true);
                        captchaHandler("panHandler");
                        setIsButtonLoading((prev) => !prev);
                      }}
                    />
                  </div>
                  {/* <div className="mt-[16px] md:mt-0"></div>
                  {!(subChannel === "web" && mi_u.slice(0, 3) === "KY3") && (
                    <div
                      className="text-center md:text-left underline text-blue cursor-pointer md:mt-1.5 mb-3 md:mb-0"
                      style={{ color: "blue" }}
                    >
                      <p onClick={clickHandler} id="otherDocsKyc">
                        Use other documents to submit your KYC
                      </p>
                    </div>
                  )} */}
                </>
              )}
            </>
          )}
          {errDrawer && (
            <ErrorBottomDrawer
              extraNotes="Oops! Something Went Wrong"
              errorMessage="Cersai is currently unavailable. Please try again later or use Aadhaar or OVD journey for KYC."
              onClickHandler={() => setErrDrawer(false)}
            />
          )}
          {captchaErrDrawer && (
            <ErrorBottomDrawer
              extraNotes="Error"
              errorMessage="CAPTCHA verification failed!"
              onClickHandler={() => setCaptchaErrDrawer(false)}
            />
          )}
          {isCersaiLoading && <Loadingoverlay />}
          <CommonTemplate2
            isTemplateOpen={open}
            okTemplate={handleClose}
            closeTemplate={handleClose}
            modalLabel={"Pan card type error"}
            kycType="Individual"
          >
            <p>PAN entered is not of Individual Type.</p>
          </CommonTemplate2>

          <CommonTemplate3
            isTemplateOpen={openCersaiOtp}
            submitTemplate={panHandler}
            closeTemplate={closeOtpTemplate}
            modalLabel={ ckycOtpRes?.result || "Enter Valid Otp"}
            kycType="Cersai"
            btnText="Proceed"
            crossIcon = {false}
            linkButton = {true}
            otpValueLength = {otpValue?.length}
          >
            {cersai_error && <p style={{fontWeight:"400", marginBottom:'10px'}}>{cersai_error}</p>}
            <div style={{display:"flex",flexDirection:"row",justifyContent:"center"}}>
            <OtpInput
              autofocus
              numInputs={6}
              value={otpValue}
              isInputNum={true}
              inputStyle={`${styles["otp-input"]} focus:ring-0 `}
              onChange={(otpValue) => setOtpValue(otpValue)}
              focusStyle={styles["focus-style"]}
              separator={<span>&nbsp;&nbsp;</span>}
              shouldAutoFocus
            />
            </div>
          </CommonTemplate3>
           {idvModal && 
             <CommonTemplate4
             isTemplateOpen={idvModal}
             okTemplate={handleClose}
            submitTemplate={eddHandler}
             closeTemplate={handleClose}
             modalLabel={"EDD Data"}
           >
           <p className="md:text-center text-sm">
                        {`As per IRDAI norms, filling of EDD questionnaire against your KYC with the name `}
                        &nbsp;
                        <span className="capitalize">{name || kycName}</span>
                        {` is mandatory. Please click on proceed button to continue.`}

                    </p>
           </CommonTemplate4>
}
        </>
      )}
    </>
  );
};

export default PanCardFrame;

// ----------PROD CODE PAN + DOB/MOBILE NUIMBER----------

// import { React, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import CommonButton from "../../../Components/global-components/CommonButton/CommonButton";
// import ToggleButton from "../../../Components/kyc-components/ToggleButton";
// import { useDispatch, useSelector } from "react-redux";
// import { panUserdata, userPanNumber } from "../../Redux/panCardSlice";
// import Loadingoverlay from "../../../Components/global-components/LoadingOverlay/Loadingoverlay";
// import TextInput from "../../../Components/global-components/CommonTextInput/TextInput";
// import { toggleButton } from "../../Redux/switchToggleSlice";
// import { toggleTabs, disableTab } from "../../Redux/slice";
// import OtherDocsFrame from "./OtherDocsFrame";
// import {
//   getPanCardDetails,
//   getPanCardDetailsV2,
//   getPanCardDetailsV3, // CERSAI API CALL 
// } from "../../../services/panCard-service";
// import { activeStepper } from "../../Redux/stepperSlice";
// import BottomCard from "../../../Components/login-components/bottom-card/BottomCard";
// import CommonDropDown from "../../../Components/global-components/CommonDropDown/CommonDropDown";
// import AadhaarCardFrame from "./AadhaarCardFrame/AadhaarCardFrame";
// import {
//   gaFunction,
//   MAX_ATTEMPT_TIME_LIMIT,
//   scrollIntoViewFunc,
// } from "../../../Router";
// import { kycRefIdAddNewKyc } from "../../Redux/kycDetailsSlice";
// import { showGlobalError } from "../../Redux/globalErrorSlice";
// import Cookies from "universal-cookie";
// // import { decrypt } from "../../../utils/encryption";
// import { updateUserData } from "../../Redux/userData";
// import { encrypt, decrypt } from "../../../utils/encryptionV2";
// import ErrorBottomDrawer from "../../../Components/global-components/ErrorBottomDrawer/ErrorBottomDrawer";

// // CAPTCHA SERVICE
// import { getCaptcha, postCaptcha } from "../../../services/captcha-service";
// import SyncOutlinedIcon from "@mui/icons-material/SyncOutlined";
// import { Tooltip } from "@mui/material";
// import InfoIcon from "@mui/icons-material/Info";
// import {CommonTemplate ,CommonTemplate2 , CommonTemplate3} from "../../../Components/global-components/CommonModal";
// import OtpInput from "react-otp-input";
// import styles from "../../OtpScreen/OtpScreen.module.css";
// import { sendCkycOtp } from "../../../services/ckyc-otp-service.js";
// import CommonRadioButton from "../../../Components/global-components/CommonRadioButton/CommonRadioButton";

// const PanCardFrame = ({
//   setCersaiLoader,
//   setControllerState,
//   controller,
//   signal,
// }) => {
//   const navigate = useNavigate();
//   const cookies = new Cookies();
//   const userDetails = useSelector((state) => state.userDetails.userData);
//   const { panNumber: reduxPanNumber, dob: reduxDob } = userDetails;
//   const [panValidationError, setpanValidationError] = useState(null);
//   const [errorMessage, setErrorMessage] = useState(null);
//   const [showOtherDocs, setShowOtherDocs] = useState(false);
//   const [isButtonLoading, setIsButtonLoading] = useState(false);
//   const [panNumber, setPanNumber] = useState(reduxPanNumber);
//   const [dob, setDob] = useState(reduxDob);
//   const [switchTab, setSwitchTab] = useState(false);
//   const [isDeclarationChecked, setIsDeclarationChecked] = useState(true);
//   const [errDrawer, setErrDrawer] = useState(false);

//   // const userlocation = useSelector((state) => state.userDetails.geolocation);
//   const istoggle = useSelector((state) => state.switchButton.activeSwitch);
//   const activeTabs = useSelector((state) => state.Tabs.activeTab);
//   const { channelUrl, mi_u, subChannel } = useSelector(
//     (state) => state.partnerChannelNameSlice.marutiUserDetails
//   );
//   const kyc_id = useSelector((state) => state.kycDetails.kycRefId);
//   const dispatch = useDispatch();
//   const [open, setOpen] = useState(false);
//   const handleOpen = () => {
//     setOpen(true);
//   };
//   const handleClose = () => {
//     setOpen(false);
//   };

//   // const [userPanData, setUserPanData] = useState("");
//   const [isLoading, setIsloading] = useState(false);
//   const [isCersaiLoading, setIsCersailoading] = useState(false);
//   function changedateformat(val) {
//     const myArray = val.split("-");
//     let year = myArray[0];
//     let month = myArray[1];
//     let day = myArray[2];
//     let formatteddate = day + "-" + month + "-" + year;
//     return formatteddate;
//   }

//   const [capthaValidationErr, setCapthaValidationErr] = useState("");
//   const [captchaError, setCaptchaError] = useState("");
//   const [imgUrl, setImgUrl] = useState(null);
//   const [captchaVal, setCaptchaVal] = useState(null);
//   const [sessionID, setSessionID] = useState(null);
//   const [captchaErrDrawer, setCaptchaErrDrawer] = useState(false);
//   const [openCersaiOtp, setOpenCersaiOtp] = useState(false);
//   const [userNumber, setUserNumber] = useState("");
//   const [otpValue, setOtpValue] = useState("");
//   const [ckycOtpRes, setCkycOtpRes] = useState(null);
//   const [isRotating, setIsRotating] = useState(false);
//   const [radioBtnSelectedValue ,setRadioBtnSelectedValue] = useState("MOBILE");

//   const panRadioValueHandleChange =(e) => {
//     setRadioBtnSelectedValue(e.target.value)
//   }  
  
//   const panChangeHandler = (value) => {
//     let regexPan = /[A-Z]{5}\d{4}[A-Z]{1}/i;
//     value = value?.replace(/\s/g, "");
//     if (value.length <= 10) {
//       setPanNumber(value);
//     }
//     setpanValidationError(null);
//     if (!regexPan.test(value)) {
//       setpanValidationError("Enter valid PAN Number.");
//     }
//   };

//   const cersai_error = localStorage.getItem("Cersai_error") || null;
//   const cersai_requestID = localStorage.getItem("cersai_requestID") || null;
  
//   useEffect(()=>{
//      if(cersai_error){
//       setOpenCersaiOtp(true);
//     }
//   },[])

//   // panHandler2 function is used for  | -- CERSAI OTP FLOW
//   const panHandler2 = () => {
//     if(!panValidationError && isDeclarationChecked && panNumber && userNumber) {
//       if (panNumber && !["P"].includes(panNumber[3])) {
//         setIsloading(false);
//         setIsButtonLoading((pre) => !pre);
//         handleOpen();
//       } else {
//         setOtpValue("");
//         setIsCersailoading(true);
//         sendCersaiOtp();
//       }
//     } else {
//       if(!panNumber && !userNumber) setErrorMessage("Fill in all required details.");
//       if(!panNumber) setpanValidationError("Enter valid PAN Number.");
//       if(!userNumber) setErrorMessage("Please enter valid mobile no.");
//       setIsloading(false);
//     }
//   };

//   const panHandler = () => {
//     gaFunction("PAN (CkYC)", "PAN (CKYC) Proceed clicked");

//     if(!cersai_requestID) {
//     localStorage.setItem('cersai_requestID' , ckycOtpRes?.requestId)
//    }

//     if (panNumber && !["P"].includes(panNumber[3])) {
//       setIsloading(false);
//       setIsButtonLoading((pre) => !pre);
//       handleOpen();
//     } else {
//       setCersaiLoader(true); // NEW LOADER
//     }
//     // if ((!panValidationError && isDeclarationChecked && panNumber) || otpValue.length === 6 ) {
//     if (!panValidationError && isDeclarationChecked ) {
//       let pan_mobile_data = JSON.stringify({
//         panNo: panNumber,
//         dob: changedateformat(dob),
//         name: userDetails.name,
//         mobile: userDetails.phoneNumber,
//         mobileRedirect: userDetails?.mobileNumber || "",
//         channel: channelUrl,
//         txnId: mi_u || localStorage.getItem("txnId"),
//         kyc_id,
//         customerType: "I",
//         requestId: ckycOtpRes?.requestId || cersai_requestID,
//         otp: otpValue,
//       });
//       let pan_dob_data = JSON.stringify({
//         panNo: panNumber,
//         dob: changedateformat(dob),
//         name: userDetails.name,
//         mobile: userDetails.phoneNumber,
//         mobileRedirect:userDetails?.mobileNumber ||"",
//         channel: channelUrl,
//         txnId: mi_u || localStorage.getItem("txnId"),
//         kyc_id,
//         customerType: "I",
//       });
//       const data = radioBtnSelectedValue === "MOBILE" ? pan_mobile_data : pan_dob_data
//       const panCardServiceCall = radioBtnSelectedValue === "MOBILE" ? getPanCardDetailsV3 : getPanCardDetailsV2

//       if (panNumber && !["P"].includes(panNumber[3])) {
//         setIsloading(false);
//         setIsButtonLoading((pre) => !pre);
//         handleOpen();
//       } else {
//         setIsloading(true);
//         setIsButtonLoading((pre) => !pre);
//         if (true) {
//           setControllerState(controller); // SET CONTROLLEER HERE
//           panCardServiceCall(
//             { enc_request: encrypt(data) },
//             encodeURIComponent(encrypt(`txnid=${mi_u}`)),
//             signal
//           )
//             .then(function (response) {
//               // dispatch(disableTab(true));
//               let decData = decrypt(response.enc_response);
//               let extractedData = decData.data;
//               console.log("extractedData from PAN", extractedData);
//               // DEDUPESD CONCEPT ADDED IF PAN ALREDY EXIST THEN GO OT SUCCESS PAGE
//               if (extractedData?.exists) {
//                 setCersaiLoader(false); // CLOSE LOADER HERE
//                 console.log("---DEDUPED FOR PAN---");
//                 setIsloading(false);
//                 dispatch(activeStepper(3));
//                 navigate("/Success", {
//                   state: {
//                     kyc_ref_id: extractedData?.kyc_id,
//                     typeOfKyc: extractedData?.status,
//                   },
//                 });
//               } else {
//                 setCersaiLoader(false); // CLOSE LOADER HERE
//                 console.log("ELSE PAN create new one");
//                 navigate("/panDetails", {
//                   state: {
//                     isRouteAllowed: true,
//                   },
//                 });
//                 // let decData= decrypt(response.enc_response)
//                 // let extractedData = decData.data;
//                 //old
//                 //   dispatch(panUserdata(extractedData));
//                 //   dispatch(updateUserData({ name: extractedData.fullName }));
//                 //new
//                 dispatch(
//                   panUserdata({ ...extractedData, dob: changedateformat(dob) })
//                 );
//                 dispatch(updateUserData({ name: extractedData?.fullName }));
//                 dispatch(kycRefIdAddNewKyc(extractedData?.kyc_id || ""));
//                 dispatch(userPanNumber(panNumber));
//                 dispatch(activeStepper(1));
//                 setIsloading(false);
//                 setIsButtonLoading((prev) => !prev);
//               }
//             })
//             .catch(function (error) {
//               setCersaiLoader(false); // CLOSE LOADER HERE
//               // dispatch(disableTab(true));
//               console.log("catch main error", error);
//               if (
//                 error?.response?.data?.message ===
//                 "No CKYC number found for the given pan number, click ok to proceed with Other Documents"
//               ) {
//                 setTimeout(() => {
//                   setSwitchTab(true);
//                   // dispatch(toggleTabs("otherDocs"));
//                   dispatch(toggleTabs("aadhaar"));
//                 }, 1000);
//               }
//               // handle error
//               else {

//                 if (error.response.data.message.includes('Invalid OTP')) {
//                   localStorage.setItem("Cersai_error", error.response.data.message);
//                 } else {
//                   console.log("handle cersai error on catch");
//                   setIsloading(false);
//                   setErrDrawer(true);
//                   setSwitchTab(true);
//                   //   dispatch(toggleTabs("otherDocs"));
//                   dispatch(toggleTabs("aadhaar"));
//                   // OTP | after 3 wrong OTP attempt both local items set as null
//                   console.log("-------------CLEAR HERE CERSAI OTP && EROR-------------------------------------------");
//                   localStorage.removeItem("Cersai_error", null);
//                   localStorage.removeItem('cersai_requestID' , null)
//                 }
//               }
//               setIsloading(false);
//               setIsButtonLoading((prev) => !prev);
//             });
//         } else {
//           // setIsloading(false);
//           // setIsButtonLoading((prev) => !prev);
//           // dispatch(
//           //   showGlobalError(
//           //     "Please try again after 15 Minutes. Maximum attempt exceeded for PAN."
//           //   )
//           // );
//           // cookies.set("pan_attempts", +cookies.get("pan_attempts"), {
//           //   expires: new Date(Date.now() + MAX_ATTEMPT_TIME_LIMIT * 1000),
//           // });
//           // return;
//         }
//       }
//     } else {
//       setCersaiLoader(false); // CLOSE LOADER HERE
//       setErrorMessage("Fill in all required details.");
//       setIsloading(false);
//       if (!panNumber || panValidationError) {
//         scrollIntoViewFunc("pan_number");
//       } else if (!dob) {
//         scrollIntoViewFunc("dob");
//       } else if (!isDeclarationChecked) {
//         scrollIntoViewFunc("pan_dec_checkbox");
//       }

//       // setIsButtonLoading((prev) => !prev);
//     }
//   };

//   const toggleButtonChangeHandler = (e) => {
//     dispatch(toggleButton(e.target.checked));
//     // if (!e.target.checked) dispatch(toggleTabs("otherDocs"));
//     if (!e.target.checked)
//       navigate("/digitalFormSixty", { state: { methodOfKyc: "pan" } });
//   };

//   const clickHandler = () => {
//     if (panNumber && !["P"].includes(panNumber[3])) {
//       setIsloading(false);
//       setIsButtonLoading((pre) => !pre);
//       handleOpen();
//       return;
//     }
//     gaFunction("OVD", "OVD Clicked");
//     setShowOtherDocs(true);
//     navigate("/kyc");
//     dispatch(toggleTabs("otherDocs"));
//     // dispatch(toggleButton(false));
//   };

//   useEffect(() => {
//     dispatch(activeStepper(0));
//   }, []);

//   // useEffect(() => {
//   //   dispatch(toggleButton(true));
//   //   // return () => dispatch(toggleButton(true));
//   // }, [dispatch]);

//   useEffect(() => {
//     let reduxPanValue = reduxPanNumber;
//     reduxPanValue = reduxPanValue?.replace(/\s/g, "");
//     if (reduxPanValue?.length == 10) {
//       setPanNumber(reduxPanValue);
//     } else {
//       setPanNumber("");
//     }
//     setDob(reduxDob);
//   }, [reduxDob, reduxPanNumber]);

//   // CAPTCHA CODE ---STRART---

//   useEffect(() => {
//     generateCaptcha();
//   }, []);

//   function generateCaptcha() {
//     getCaptcha().then((data) => {
//       let decResponse = decrypt(data.enc_response);
//       setSessionID(decResponse?.capthchaSessionID);
//       sessionStorage.setItem("sessionID", decResponse?.capthchaSessionID);
//       let svgString = decResponse?.captchaSvg?.replace(/\\/g, "");
//       const svgDataUrl = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
//         svgString
//       )}`;
//       setImgUrl(svgDataUrl);
//     });
//   }

//   function captchaChangeHandler(value) {
//     value = value?.replace(/\s/g, "");
//     if (value.length <= 6) {
//       setCaptchaVal(value);
//       setCapthaValidationErr("");
//     }
//   }

//   function regeneratCaptcha(e) {
//     e.preventDefault();
//     setIsRotating(true);
//     setTimeout(()=>setIsRotating(false),1500);
//     generateCaptcha();
//     setCaptchaVal("");
//     setCapthaValidationErr("");
//   }

//   const captchaHandler = (btnType) => {
//     if (captchaVal?.length === 6) {
//       console.log(captchaVal);
//       const storedValue = sessionStorage.getItem("sessionID");
//       if (captchaVal === storedValue) {

//         if( radioBtnSelectedValue === "DOB") {
//           if(btnType === "ovdHandler") { 
//             clickHandler()
//           }

//           if( btnType === "panHandler" && dob ) {
//             btnType === "panHandler" &&  panHandler() 
//           } else {
//             setErrorMessage("Please enter valid date of birth.");
//             return
//           }
//         } 
        
//         if (radioBtnSelectedValue === "MOBILE") {
//           if(btnType === "ovdHandler") {
//             clickHandler() 
//           }
//           if(btnType === "panHandler" && userNumber?.length == 10) {
//              panHandler2()
//           } else {
//             setErrorMessage("Please enter mobile number.");
//             return
//           }

//           // btnType === "panHandler" ? panHandler2() : clickHandler();
//         } 
//         // NEW model switcher flow | depends on RADIO BUTTONS
//         // btnType === "panHandler" ? radioBtnSelectedValue === "MOBILE" ? panHandler2() : panHandler() : clickHandler();
//         // LATEST flow with | Replace DOB with mobilNumber fro cersai OTP
//         // btnType === "panHandler" ? panHandler2() : clickHandler();
//         // OLD flow with | DOB
//         // btnType === 'panHandler' ? panHandler() : clickHandler()
//         sessionStorage.removeItem("sessionID");
//         setCaptchaVal("");
//         generateCaptcha();
//       } else {
//         setCaptchaErrDrawer(true);
//         generateCaptcha();
//         setCaptchaVal("");
//       }
//     } else {
//       let errmsg = btnType === "panHandler" ? "Proceed" : "OVD";  
//       setCaptchaError(true);
//       scrollIntoViewFunc("captcha_number");
//       setCapthaValidationErr(`Please enter valid captcha to ${errmsg}.`);
//       setIsButtonLoading((prev) => !prev);
//     }
//   };

//   const validateAndSetUserNumber = (value) => {
//     let mobileNumberRegex = /^\d{10}$/
//     value = value?.replace(/[^0-9]/g, '')
//     console.log(mobileNumberRegex.test(value))
//     if (value.length <= 10  ) {
//       setUserNumber(value);
//     }
//     // eslint-disable-next-line no-invalid-regexp
//     setErrorMessage(null);
//     if (!mobileNumberRegex.test(value)) {
//       setErrorMessage("Please enter valid mobile no.");
//     }
//   };

//   const sendCersaiOtp = () => {

//     let data = JSON.stringify({
//       panNo: panNumber,
//       mobileNumber: userNumber, // --- for CERSAI OTP use this key
//       mobile: userDetails.phoneNumber,
//       name: userDetails.name,
//       mobileRedirect: userDetails?.mobileNumber || "",
//       channel: channelUrl,
//       txnId: mi_u || localStorage.getItem("txnId"),
//       kyc_id,
//       customerType: "I",
//       requestId: ckycOtpRes?.requestId || cersai_requestID,
//       otp: otpValue,
//     });

//     sendCkycOtp({ enc_request: encrypt(data) })
//       .then(function (response) {
//         console.log("sendCkycOtp res", response);
//         let decData = decrypt(response.enc_response);
//         let extractedData = decData.data;
//         // DEDUPESD CONCEPT ADDED IF PAN ALREDY EXIST THEN GO OT SUCCESS PAGE
//         if (extractedData?.exists) {
//           setIsloading(false);
//           setIsCersailoading(false);
//           dispatch(activeStepper(3));
//           navigate("/Success", {
//             state: {
//               kyc_ref_id: extractedData?.kyc_id,
//               typeOfKyc: extractedData?.status,
//             },
//           });
//         } else {
//           console.log("sendCkycOtp res dec", decData);
//           setCkycOtpRes(decData.data);
//           setIsCersailoading(false);
//           setOpenCersaiOtp(true);
//         }
//       })
//       .catch(function (err) {
//         console.log("sendCkycOtp err", err);
//         setIsCersailoading(false);
//         setOpenCersaiOtp(false);
//       });
//   };

//   // Redirect or cancel journy of OTP using this function
//   const closeOtpTemplate = () => {
//     localStorage.removeItem("Cersai_error", null);
//     localStorage.removeItem('cersai_requestID' , null)
//     setSwitchTab(true);
//     dispatch(toggleTabs("aadhaar"));
//     setOpenCersaiOtp(false)
//   }

//   return (
//     <>
//       {isLoading ? (
//         <Loadingoverlay />
//       ) : (
//         <>
//           {showOtherDocs || istoggle === false ? (
//             // <OtherDocsFrame />
//             navigate("/digitalFormSixty", { state: { methodOfKyc: "pan" } })
//           ) : (
//             <>
//               {!showOtherDocs && (
//                 <>
//                   <div className="mt-[16px]"></div>

//                   <div className="  md:overflow-scroll md:p-0 ">
//                     {!(subChannel === "web" && mi_u.slice(0, 3) === "KY3") && (
//                       <div className="flex   gap-[10px]  items-center max-w-[100%]">
//                         <p>Do you have a valid PAN Number?</p>
//                         <ToggleButton
//                           onChange={(e) => toggleButtonChangeHandler(e)}
//                           checked={istoggle}
//                         />
//                       </div>
//                     )}
//                     <div className="mt-2">
//                       <label
//                         htmlFor="first_name"
//                         className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-700"
//                       >
//                         PAN No.
//                       </label>
//                       <TextInput
//                         placeholder={"PAN Number"}
//                         width="md:w-[300px]"
//                         value={panNumber}
//                         onChange={(e) =>
//                           panChangeHandler(e.target.value.toUpperCase())
//                         }
//                         success={
//                           panValidationError || panNumber?.length <= 0
//                             ? false
//                             : true
//                         }
//                         id="pan_number"
//                         required
//                       />
//                       {panValidationError && (
//                         <p className="text-red-500 text-sm">
//                           {panValidationError}
//                         </p>
//                       )}
//                     </div>

//                     <>
//                      <label
//                         htmlFor="first_name"
//                         className="block mt-2 text-sm font-medium text-gray-900 dark:text-gray-700"
//                         >
//                         USING.
//                       </label>
//                       <CommonRadioButton
//                       handleChangeValue={panRadioValueHandleChange}
//                       selectRadioBtn={radioBtnSelectedValue}
//                       />
//                       </>
//                       {radioBtnSelectedValue === "DOB" ?
//                     <>
//                     <div className="">
//                       <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-700">
//                             Date of birth.
//                           </label>
//                     </div>
//                     <input
//                           id="dob"
//                           className=" border border-gray-500 border-opacity-30 placeholder-gray-500 placeholder-opacity-50 w-full md:max-w-[300px] p-[6px] uppercase"
//                           type="date"
//                           value={dob}
//                           onChange={(e) =>{if(e.target.value?.trim()?.length <= 10){setDob(e.target.value)}}}
//                           />
//                       </> : 
//                     <TextInput
//                       id={"loginNumberField"}
//                       value={userNumber}
//                       width="md:w-[300px]"
//                       type="tel"
//                       label={"Mobile number"}
//                       placeholder={"Eg.99999 00000"}
//                       onChange={(e) => validateAndSetUserNumber(e.target.value)}
//                     />}
//                     {errorMessage && (
//                       <p className="text-red-500 mt-2">{errorMessage}</p>
//                     )}
//                      <div
//                       className="captcha-div"
//                       style={{ display: "flex", marginTop: "15px" }}
//                     >
//                       <img
//                         src={imgUrl}
//                         style={{
//                           border: "1px solid #d1d5db",
//                           padding: "5px",
//                           borderRadius: "10px",
//                           marginRight: "12px",
//                         }}
//                         alt="Captcha Img"
//                       />
//                       <Tooltip
//                         style={{ margin: "20px 15px 0px 0px" }}
//                         id="button-report1"
//                         title={"Captcha is mandate from Infosec point of view"}
//                       >
//                         <InfoIcon sx={{ color: "black", fontSize: "17px" }} />
//                       </Tooltip>
//                       <SyncOutlinedIcon
//                         sx={{
//                           color: "black",
//                           fontSize: "25px",
//                           marginTop: "15px",
//                           marginRight: "10px",
//                           cursor: "pointer",
//                           animation: isRotating ?"rotate360 1.5s ease-in-out":"none"
//                         }}
//                         onClick={(e) => regeneratCaptcha(e)}
//                       />
//                       <TextInput
//                         placeholder={"Enter Captcha"}
//                         // width="md:w-[300px]"
//                         value={captchaVal}
//                         onChange={(e) => captchaChangeHandler(e.target.value)}
//                         success={captchaVal <= 0 ? false : true}
//                         //  id="captcha_number"
//                         required
//                       />
//                     </div>
//                     {captchaError && (
//                       <p
//                         className="text-red-500 text-sm"
//                         style={{ marginTop: "5px" }}
//                       >
//                         {capthaValidationErr}
//                       </p>
//                     )}

//                     <div id="captcha_number" style={{ margin: "20px" }}></div>
//                     <div className="flex mt-2">
//                       <input
//                         id="pan_dec_checkbox"
//                         type="checkbox"
//                         value={isDeclarationChecked}
//                         checked={isDeclarationChecked}
//                         className="w-5 h-5  rounded border-gray-300 text-primaryH ring-0 focus:ring-0"
//                         onChange={(e) =>
//                           setIsDeclarationChecked(e.target.checked)
//                         }
//                       />
//                       <label
//                         htmlFor="link-checkbox"
//                         className="ml-2 text-sm font-medium text-black "
//                         style={{fontSize:"12px"}}
//                       >
//                         I hereby provide my consent to HDFC ERGO General
//                         Insurance Company Limited to retrieve/ verify my KYC
//                         documents like Address /ID proof and photograph, from
//                         the CERSAI portal against my PAN No. I understand that
//                         the said KYC documents shall be relied upon by the
//                         Company for processing my policy/refunds/ Claims.
//                       </label>
//                     </div>
                   
//                   </div>
//                   <div className="w-full mt-5 md:mt-0 md:w-[300px] flex md:pb-1">
//                     <CommonButton
//                       label="Proceed"
//                       filled
//                       arrow
//                       // loading={isButtonLoading}
//                       id={"toCompletePanKyc"}
//                       onClickHandler={() => {
//                         //  setIsloading(true);
//                         captchaHandler("panHandler");
//                         setIsButtonLoading((prev) => !prev);
//                       }}
//                     />
//                   </div>
//                   <div className="mt-[16px] md:mt-0"></div>
//                   {!(subChannel === "web" && mi_u.slice(0, 3) === "KY3") && (
//                     <div
//                       className="text-center md:text-left underline text-blue cursor-pointer md:mt-1.5 mb-3 md:mb-0"
//                       style={{ color: "blue" }}
//                     >
//                       {/* {!partnerDigiJourneyFlag && ( */}
//                       {/* <p onClick={clickHandler} id="otherDocsKyc"> */}
//                       <p
//                         onClick={() => captchaHandler("ovdHandler")}
//                         id="otherDocsKyc"
//                       >
//                         Use other documents to submit your KYC
//                       </p>
//                       {/* )} */}
//                     </div>
//                   )}
//                 </>
//               )}
//             </>
//           )}
//           {errDrawer && (
//             <ErrorBottomDrawer
//               extraNotes="Oops! Something Went Wrong"
//               errorMessage="Cersai is currently unavailable. Please try again later or use Aadhaar or OVD journey for KYC."
//               onClickHandler={() => setErrDrawer(false)}
//             />
//           )}
//           {captchaErrDrawer && (
//             <ErrorBottomDrawer
//               extraNotes="Error"
//               errorMessage="CAPTCHA verification failed!"
//               onClickHandler={() => setCaptchaErrDrawer(false)}
//             />
//           )}
//           {isCersaiLoading && <Loadingoverlay />}
//           <CommonTemplate2
//             isTemplateOpen={open}
//             okTemplate={handleClose}
//             closeTemplate={handleClose}
//             modalLabel={"Pan card type error"}
//             kycType="Individual"
//           >
//             <p>PAN entered is not of Individual Type.</p>
//           </CommonTemplate2>

//           <CommonTemplate3
//             isTemplateOpen={openCersaiOtp}
//             submitTemplate={panHandler}
//             closeTemplate={closeOtpTemplate}
//             modalLabel={ ckycOtpRes?.result || "Enter Valid Otp"}
//             kycType="Cersai"
//             btnText="Proceed"
//             crossIcon = {false}
//             linkButton = {true}
//             otpValueLength = {otpValue?.length}
//           >
//             {cersai_error && <p style={{fontWeight:"400", marginBottom:'10px'}}>{cersai_error}</p>}
//             <div style={{display:"flex",flexDirection:"row",justifyContent:"center"}}>
//             <OtpInput
//               autofocus
//               numInputs={6}
//               value={otpValue}
//               isInputNum={true}
//               inputStyle={`${styles["otp-input"]} focus:ring-0 `}
//               onChange={(otpValue) => setOtpValue(otpValue)}
//               focusStyle={styles["focus-style"]}
//               separator={<span>&nbsp;&nbsp;</span>}
//               shouldAutoFocus
//             />
//             </div>
//           </CommonTemplate3>
//         </>
//       )}
//     </>
//   );
// };

// export default PanCardFrame;


